import { LayoutGrid, Rows3 } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { ButtonGroup } from "@/shared/components/ui/button-group";
import type { DashboardSectionView } from "../hooks/use-dashboard-view-preferences";

type DashboardSectionViewToggleProps = {
  value: DashboardSectionView;
  onChange: (value: DashboardSectionView) => void;
};

export function DashboardSectionViewToggle({
  value,
  onChange,
}: DashboardSectionViewToggleProps) {
  return (
    <ButtonGroup className="rounded-xl border border-border/70 bg-muted/30 p-1">
      <Button
        type="button"
        size="sm"
        variant={value === "table" ? "secondary" : "ghost"}
        className="h-8 rounded-lg px-3"
        onClick={() => onChange("table")}
      >
        <Rows3 className="size-4" />
        Table
      </Button>
      <Button
        type="button"
        size="sm"
        variant={value === "carousel" ? "secondary" : "ghost"}
        className="h-8 rounded-lg px-3"
        onClick={() => onChange("carousel")}
      >
        <LayoutGrid className="size-4" />
        Carousel
      </Button>
    </ButtonGroup>
  );
}
